import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const getVideos = createAsyncThunk('gallery/getVideos',
  async () => {
    const url = `v1/mobile/video_galleries`
    const response: AxiosResponse<VideosPagination> = await instance.get(url)
    return response.data
  })

export const addVideo = createAsyncThunk('gallery/addVideo',
  async (data: VideoPayload) => {
    const response: AxiosResponse<Video> = await instance.post('v1/mobile/video_galleries', data)
    return response.data
  })

export const deleteVideo = createAsyncThunk('gallery/deleteVideo',
  async (id: string) => {
    const response: AxiosResponse<Video> = await instance.delete(`v1/mobile/video_galleries/${id}`)
    return response.data
  })


